import React, { useContext, useEffect, useState } from "react";
import { VendorSourcesHeader } from "../VendorSourcesHeader/VendorSourcesHeader";
import OwTitle from "../../shared/OwTitle/OwTitle";
import TitleTagEnum from "../../../models/TitleTagEnum";
import OwButton from "../../shared/OwButton/OwButton";
import OwTable from "../../shared/OwTable/OwTable";
import IOwTableCols from "../../../models/IOwTableCols";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import IGetSupplierVendorSourceUsersTokensDTO from "../../../models/DTO/IGetSupplierVendorSourceUsersTokenDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnGetSupplierVendorSourceUsersTokensDTO from "../../../models/DTO/IOnGetSupplierVendorSourceUsersTokensDTO";
import IConnection_Token from "../../../models/IConnection_Token";
import { VendorSourcesUsersSidebar } from "../VendorSourcesUsersSidebar/VendorSourcesUsersSidebar";
import OwLabel from "../../shared/OwLabel/OwLabel";
import BetaBadge from "../../shared/BetaBadge/BetaBadge";
import SocketService from "../../../services/SocketService";
import UiContext from "../../../contexts/UiContext";
import { SocketContext } from "../../../contexts/SocketContext";

type Props = {};

export const VendorSourcesUsers: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const uiContext = useContext(UiContext);
    const socket = useContext(SocketContext)!;

    const renderVendorSourceName = (row: IConnection_Token) => {
        return row.Vendor_Source?.name;
    };

    const getRegistrationUrl = (row: IConnection_Token): string => {
        const value = row.value;

        const siteUrl = SocketService.getStaticSiteUrl();

        let register = `/register?t=${value}`;

        if (siteUrl.indexOf("8080") >= 0) {
            register = `/register?t=${value}`;
        }

        const registrationUrl = `${siteUrl}${register}`;

        return registrationUrl;
    };

    const renderUser = (row: IConnection_Token) => {
        if (row.User) {
            return row.User?.name;
        } else {
            return (
                <div>
                    <div>
                        {row.recipient}
                        <BetaBadge title={"pending"} className={"ms-2"} />
                        <div className={"registration-url text-small"}>
                            <OwLabel title={"registration_url"} noBottomMargin={true} className={"me-2"} />
                            <a href={getRegistrationUrl(row)} target={"_blank"} rel="noreferrer">
                                {getRegistrationUrl(row)}
                            </a>
                        </div>
                    </div>
                </div>
            );
        }
    };

    const renderEmail = (row: IConnection_Token) => {
        return row.User?.email;
    };

    const renderActions = (row: IConnection_Token) => {
        return <div></div>;
    };

    const getTableCols = (): IOwTableCols[] => {
        return [
            { title: "vendor_source", renderFnEmitsRow: true, renderFn: renderVendorSourceName, valueProp: "" },
            { title: "user", renderFnEmitsRow: true, renderFn: renderUser, valueProp: "" },
            { title: "email", renderFnEmitsRow: true, renderFn: renderEmail, valueProp: "" },
            { title: "actions", renderFnEmitsRow: true, renderFn: renderActions, valueProp: "" },
        ];
    };

    const [totalTokens, setTotalTokens] = useState(0);
    const [tokens, setTokens] = useState<IConnection_Token[]>([]);
    const [tableCols, setTableCols] = useState<IOwTableCols[]>(getTableCols());
    const [isDataFetching, setIsDataFetching] = useState<boolean>(false);
    const [isInitialData, setIsInitialData] = useState<boolean>(true);

    useEffect(() => {
        socket.on(EndpointsEnum.TokenOnGetSupplierVendorSourceUsersTokens, onGetVendorSourcesUsers);

        getVendorSourceUsers();

        return () => {
            socket.removeListener(EndpointsEnum.TokenOnGetSupplierVendorSourceUsersTokens, onGetVendorSourcesUsers);
        };
    }, []);

    const getVendorSourceUsers = () => {
        const payload: IGetSupplierVendorSourceUsersTokensDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.TokenGetSupplierVendorSourceUsersTokens, payload);

        setIsDataFetching(true);
    };

    const onGetVendorSourcesUsers = (data: IOnGetSupplierVendorSourceUsersTokensDTO) => {
        setTokens(data.tokens.vendorSourcesUsersTokens);
        setTotalTokens(data.totalVendorSourcesUsers);
        setIsDataFetching(false);
        setIsInitialData(false);
    };

    const closeSidebar = (refresh?: boolean) => {
        uiContext.setSidebarComponent(null);
        uiContext.toggleSidebar(false);

        if (refresh) {
            getVendorSourceUsers();
        }
    };

    const showCreateSidebar = () => {
        const sidebarComponent = <VendorSourcesUsersSidebar cancelFn={closeSidebar} notifyFn={uiContext.notifyFn} socket={socket} />;

        uiContext.setSidebarComponent(sidebarComponent);
        uiContext.toggleSidebar(true);
    };

    return (
        <div className={"VendorSourcesUsers"}>
            <VendorSourcesHeader notifyFn={uiContext.notifyFn} />

            <div className={"mt-5"}>
                <div className={"d-flex align-items-center"}>
                    <OwTitle title={"vendor_sources_users"} tag={TitleTagEnum.H3} leftIconName={"fad fa-users"} />
                    <div>
                        <OwButton className={"btn-warning ms-3"} fn={showCreateSidebar} title={"create"} leftIconClass={"fas fa-plus"} />
                    </div>
                </div>
            </div>

            <div className="mt-3 text-end">
                <OwLabel title={"total_rows"} postText={":"} /> {totalTokens}
            </div>
            <div className="mt-2">
                <OwTable
                    columns={tableCols}
                    dataSet={tokens}
                    userModel={userModel}
                    supplierModel={supplierModel}
                    dataFetch={isDataFetching}
                    initialData={isInitialData}
                />
            </div>
        </div>
    );
};
